<template>
  <a-select
    :disabled="disabled"
    :default-value="dataItem.schoolId" @change="changeSchool" placeholder="请选择学校">
    <a-select-option :value="school.schoolId" v-for="school in schoolList" :key="school.schoolId">
      {{ school.schoolName }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: 'SchoolSelector', // 学校组件
  props: {
    disabled: Boolean,
    dataItem: { // 主讲学校教室信息
      type: Object,
      default() {
        return {}
      }
    },
    schoolList: { // 学校列表
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    changeSchool(value) {
      const dataItem = {
        ...this.dataItem,
        schoolId: value
      }
      this.$emit('changeSchool', dataItem)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>